import { Spin } from 'antd';

import { useMaterialPage } from './hooks';

import MaterialsList from '~organisms/MaterialsList';
import { ProductReplacementModal } from '~organisms/ProductReplacementModal';
import MaterialsTemplate from '~templates/Materials';

const MaterialPage = () => {
  const {
    isFetchingMaterials,
    materialsList,
    selectedMaterial,
    selectMaterialId,
    closeModal,
    overwritingMaterial,
    overwriteSelectedMaterial,
    removedProducts,
  } = useMaterialPage();

  return isFetchingMaterials ? (
    <Spin style={{ fontSize: 24 }} />
  ) : (
    <>
      <MaterialsTemplate
        materialsSlot={
          <MaterialsList
            data={{ materials: materialsList }}
            selectedMaterialId={selectedMaterial?.id}
            onSelectMaterial={selectMaterialId}
          />
        }
      />

      <ProductReplacementModal
        newProductName={overwritingMaterial?.name}
        typeOfProduct="material"
        productsToReplace={removedProducts}
        onCancel={closeModal}
        onConfirm={() =>
          overwritingMaterial?.id
            ? overwriteSelectedMaterial(overwritingMaterial.id)
            : undefined
        }
      />
    </>
  );
};

export default MaterialPage;
